export const ssoConfigLocal = {
  AUTH0_CLIENT_ID: 'servisne',
  AUTH0_DOMAIN: '172.21.253.234'
}


//////////////////
// WEBPACK FOOTER
// ./static/local_config/sso_conf_local.js
// module id = yDLM
// module chunks = 3